document.addEventListener('DOMContentLoaded', () => {
    const messageElement = document.getElementById('statusMessage');
    const modal = document.getElementById('statusModal');

    document.addEventListener('show_status_modal', () => {
        messageElement.textContent = 'Trying to reconnect...';
        modal.classList.remove('hidden');
    });

    document.addEventListener('hide_status_modal', () => {
        messageElement.textContent = 'Connected!';

        setTimeout(() => {
            modal.classList.add('hidden');
        }, 1000);
    });
});
